import React from "react";
import {
  UserPlus, CheckCircle2, CreditCard, BookOpenCheck, XCircle,
  Video, FileVideo, ShieldAlert, RotateCcw, UserCog,
} from "lucide-react";
import { Panel } from "./ui";

const TYPE_META = {
  user_registered: { icon: UserPlus, tone: "text-sky-600 bg-sky-50" },
  request_approved: { icon: CheckCircle2, tone: "text-emerald-600 bg-emerald-50" },
  payment_completed: { icon: CreditCard, tone: "text-emerald-600 bg-emerald-50" },
  lesson_published: { icon: BookOpenCheck, tone: "text-indigo-600 bg-indigo-50" },
  lesson_cancelled: { icon: XCircle, tone: "text-rose-600 bg-rose-50" },
  meeting_created: { icon: Video, tone: "text-purple-600 bg-purple-50" },
  recording_uploaded: { icon: FileVideo, tone: "text-purple-600 bg-purple-50" },
  user_blocked: { icon: ShieldAlert, tone: "text-rose-600 bg-rose-50" },
  refund_issued: { icon: RotateCcw, tone: "text-amber-600 bg-amber-50" },
  profile_updated: { icon: UserCog, tone: "text-slate-600 bg-slate-100" },
};

const RecentActivityFeed = ({ data, loading, error, onRetry }) => (
  <Panel
    eyebrow="פעילות"
    title="פעילות אחרונה באתר"
    subtitle="סדר כרונולוגי"
    accent="slate"
    loading={loading}
    error={error}
    onRetry={onRetry}
    empty={!loading && !error && (!data || data.length === 0)}
  >
    <ul className="space-y-1 max-h-96 overflow-y-auto -mx-1">
      {data?.map((item) => {
        const meta = TYPE_META[item.type] || TYPE_META.profile_updated;
        const Icon = meta.icon;
        return (
          <li key={item.id}>
            <a href={item.href} className="flex items-start gap-3 px-1 py-2 rounded-xl hover:bg-gray-50 transition">
              <span className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${meta.tone}`}>
                <Icon className="w-4 h-4" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-xs text-gray-700">
                  <span className="font-bold text-gray-900">{item.actor}</span> {item.detail}
                </p>
                <p className="text-[10px] text-gray-400 mt-0.5">{item.at}</p>
              </div>
            </a>
          </li>
        );
      })}
    </ul>
  </Panel>
);

export default RecentActivityFeed;
